import { ReactElement, useEffect, useState, useRef } from 'react';
import { getLabelFallback, getItemTotalPrice, getItemDiscountedTotalPrice, convertNumber, handleHTTPError, scrollUpPage, getItemTotalPriceWithWarranty, getItemDiscountedTotalPriceWithWarranty, isThereAnAddedWarranty, getItemDeiscountedTotalPriceWithSpeedy } from '@utils/utils';
import { useDispatch, useSelector } from 'react-redux';

import * as actions from '@redux-actions/';

import CartBanner from '@components/CartBanner';
import Image from '@components/Image';
import UpsellElement from '@components/UpsellElement';

import ArrowDown from '@images/svg-icons/arrow_down.svg';
import ArrowUp from '@images/svg-icons/arrow_up.svg';
import { display } from '@mui/system';
import { any } from 'prop-types';
import { Checkbox, FormControlLabel } from '@mui/material';
import { addWarranty } from '@utils/services';
import Loader from './Loader';
import { getBrandSeoUrl } from "@utils/services";

import Info from '@images/svg-icons/info16.svg';
import Close from '@images/svg-icons/close.svg';

type CartProductTileProps = {
    item: any;
    editOrderItem?: () => void,
    removeOrderItem?: (value) => void;
    classes: string;
    orderId: number;
}

const CartProductTile = (props: CartProductTileProps) : ReactElement => {
    const {
        item,
        editOrderItem,
        removeOrderItem,
        classes,
        orderId,
    } = props;

    const dispatch = useDispatch();

    const assetsUrl = useSelector(state => state.cart.config.assetsUrl);
    const config = useSelector(state => state.cart.config);
    const upsellDetails = useSelector(state => state.cart.upsellDetails);
    const selectedShippingMode = useSelector(state => state.cart.selectedShippingMode);
    const enabledShippingModes = useSelector(state => state.cart.enabledShippingModes);

    const [lensDetailVisible, setLensDetailVisible] = useState(false);
    const [isBeingDelete, setIsBeingDelete] = useState(false);
    const [showSpeedyDetailTooltip, setShowSpeedyDetailTooltip] = useState(false);
    const speedyOrderDetails = useSelector(state => state.cart.speedyOrderDetails);

    const cart = useSelector(state => state.cart.cart);
    const [isWarrantyChecked, setWarrantyChecked] = useState(isThereAnAddedWarranty(cart, item.frame.orderItemId));
    const [seoUrl, setSeoUrl] = useState<string | null>(null);

    const isItemSpeedyEligible = speedyOrderDetails?.glassesDetails?.some(glassesDetail => item.frame.orderItemId == glassesDetail.frameOrderItemId && glassesDetail?.speedyEligible) ?? false;
    const isItemSpeedyActive = speedyOrderDetails?.glassesDetails?.some(glassesDetail => item.frame.orderItemId == glassesDetail.frameOrderItemId && glassesDetail?.speedyActive) ?? false;

    useEffect(() => {
        let isComponentMounted = false;

        async function fetchSeoUrl() {
            try {
                const url = await getBrandSeoUrl(config.hostname, config.storeId, config.catalogId, item.brand);
                if (!isComponentMounted) {
                    setSeoUrl(url);
                }
            } catch (error) {
                console.error("Errore nel caricamento della SEO URL:", error);
            }
        }

        fetchSeoUrl();

        return () => { isComponentMounted = true; };
    }, [config.hostname, config.storeId, config.catalogId, item.brand]);


    let timeoutToDelete = useRef(null);
    useEffect(() => {
        setIsBeingDelete(false);
    }, [item]);

    useEffect(() => {
        setWarrantyChecked(isThereAnAddedWarranty(cart, item.frame.orderItemId));
    }, [cart]);

    useEffect(() => {
        if(isBeingDelete === true) {
            /****** SCROLL UP ******/
            scrollUpPage(window);
            /***********************/
            dispatch(actions.setDisableNavigation(+1));
            timeoutToDelete.current = setTimeout(() => {
               removeOrderItem(item.frame.orderItemId);
               sessionStorage.removeItem("lens-package-current-session-" + item.frame.productId);
               sessionStorage.removeItem("upsell-current-session-title-"+ item.frame.orderItem);
            }, 3000);
        } else {
            clearTimeout(timeoutToDelete.current);
            if(!!timeoutToDelete.current) {
                dispatch(actions.setDisableNavigation(-1));
            }            
        }
    }, [isBeingDelete]);

    const hasInsuranceDiscount = () => {

        return item.frame.hasInsuranceCalculated === true || item.frame.totalAdjustment.code
            .concat(item.lenses.totalAdjustment.code, item.addOns.totalAdjustment.code)
            .some(el => el.code.search('INSADJ') === 0);
    }

    const getInsuranceCheck = () => {
        return (
            <label key={'promo-codes-label'}>{getLabelFallback('INSUR_DISCOUNT_LABEL')}</label>
        )
    }

    const getPromoSection = () => {
        const allPromo = item.frame.totalAdjustment.code
                            .concat(item.lenses.totalAdjustment.code, item.addOns.totalAdjustment.code)
                            .filter((v, i, a) => i === a.findIndex((t) => (
                                t.code === v.code
                            )))
                            .filter(el => el.code.search('IDME') === -1)
                            .filter(el => el.code.search('INSADJ') === -1);
        
        const insuranceIdmeActive=item.frame.totalAdjustment.code
                                .concat(item.lenses.totalAdjustment.code, item.addOns.totalAdjustment.code)
                                .filter((v, i, a) => i === a.findIndex((t) => (
                                    t.code === v.code
                                )))
                                .filter(el => (el.code.search('INSADJ') === 0));
                                
        if(!!item.sales && item.sales !== '' && insuranceIdmeActive.length==0) {
            allPromo.unshift({'description': item.sales.substring(1, item.sales.length)+ ' ' + getLabelFallback('OFF_LABEL') + ' ' + getLabelFallback('FRAME_PROMO_LABEL')});
            $('.cart-product-tile-right-top-left-brand-badge').show();
        }else if(insuranceIdmeActive.length!=0){
            allPromo.unshift({'description': getLabelFallback('INSUR_DISCOUNT_LABEL')});   
            $('.cart-product-tile-right-top-left-brand-badge').hide();        
        }else  if(!!item.sales_ea && item.sales_ea !== '' && insuranceIdmeActive.length==0 && getCookie('eaactivity')=='true' && config.ea_enabled == 'true' ) {
            $('.cart-product-tile-right-top-left-brand-badge').show();
        }
        
        return allPromo.map((item, index) => {
            return (
                <label key={'promo-codes-label' + index}>{item.description}</label>
            )
        });
    }
    
    const getItemDetailedProperty = () => {
        return item.frame.xitem_rxcReviewObject.map((p, index) => {
            if(p.name){
                if(!p.children) {
                    return  <>
                                <span key={'your-lenses-left'+index} className={'left-' + index}>{ p.name.replace(':', '') }</span>
                                <span key={'your-lenses-right'+index} className={'right-' + index}>{p.description}</span>
                            </>
                } else {
                    return <>
                                <span key={'your-lenses-left'+index} className={'left-'+ index}>{ p.name.replace(':', '') }</span>
                                <ul key={'your-lenses-right'+index} className={'right-' + index}>
                                    {
                                        p.children.map((child, index2) => {
                                            return (
                                                <li key={'cart-product-tile-details-label-' + index + '-child-'+index2} className="cart-product-tile-details-label-child">
                                                    {child.name}
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </>
                }
            }
           
        })
    }

    const getItemUpsellOption = () => {
        if((item.upsellOpions).length != 0){
            var upsellEspot = JSON.parse(upsellDetails as string);
            return item.upsellOpions.map((p) => {
                if(p != null){
                    var upsellType = getUpsellType(p); 
                    return  <>
                                <UpsellElement 
                                    upsellEspot={upsellEspot}
                                    upsellType={upsellType}
                                    upsellOption={p}
                                    itemCart={item}
                                    orderId={orderId}
                                />
                            </>
                }
            })
        }
    }

    const getUpsellType = (upsell) => {
        let upsellType = null;
        if (upsell.lensPackage.brand != item.currentPackage.brand) {
            if (upsell.lensPackage.brand == 'Ray-Ban')
                upsellType = 'authenticRB';
            else if (upsell.lensPackage.brand == 'Oakley')
                upsellType = 'authenticOO';
            else
                upsellType = 'authenticCO';
        } else if (upsell.lensPackage.antiReflective != item.currentPackage.antiReflective) {
            if (item.currentPackage.antiReflective == null || (!!item.currentPackage.antiReflective && item.currentPackage.antiReflective.toLowerCase() == "no"))
                upsellType = 'antiReflectiveStandard';
            else
                upsellType = 'antiReflectivePremium';
        } else {
            upsellType = 'blueLight';
        }
        return upsellType;
    }

    const getSpeedyRXPrice = () => {
        const speedy = enabledShippingModes.filter(mode => mode.shipModeCode.toLowerCase() === 'speedy rx')[0];
        return speedy.field2
    }

    const handleWarrantyCheckboxChange = async () => {
        setWarrantyChecked(!isWarrantyChecked);
        const warrantyServiceParams = {
            "orderId": orderId,
            "orderItemId": item.frame.orderItemId,
            "action": !isWarrantyChecked ? "ADD" : "REM",
            "lensType": item.lenses.xitem_correctionType && item.lenses.xitem_correctionType == "Progressive" ? "Progressive" : "Single Vision",
        };
        
        console.log(item.frame.xitem_rxcReviewObject)
        await addWarranty(config.hostname, warrantyServiceParams).then(async(response) => {
            dispatch(actions.getCart(config.mockRequests, config.hostname));
            })
    };

    const warrantycond= () => {
        if (item.correction_type != 'Progressive' && parseFloat(getItemDiscountedTotalPrice(item)) >= 74.99){
            return true;
        }else if(item.correction_type == 'Progressive' && parseFloat(getItemDiscountedTotalPrice(item)) >= 84.99){
            return true;
        }else{return false;}
    };
      
    return(
        <>
        <div className={`cart-product-tile-container`}>
        	{ config.isSpeedyRxEnabled === 'true' && 
        		<input type="hidden" id={`item-${item.frame.orderItemId}-speedy-active`} value={(!!isItemSpeedyActive && !!isItemSpeedyEligible).toString()} />
    		}
            <div className={`cart-product-tile ${classes}`}>
                {isBeingDelete === false &&
                    <>
                        <div className="cart-product-tile-left">
                            {!!item.frame.xitem_rxcImagery && item.frame.xitem_rxcImagery.fallbackImage !== null ?
                                <CartBanner image={item.frame.xitem_rxcImagery.fallbackImage}
                                    title={getLabelFallback('LENS_COLOR_PREVIEW_NOT_AVAILABLE')}
                                    text={getLabelFallback('LENS_COLOR_PREVIEW_TEXT')}    
                                /> :
                                <div></div>
                            }
                            {config.isSpeedyRxEnabled === 'true' && !!item.lenses && !!item.lenses.xitem_rxcLensIsSpeedyRx && item.lenses.xitem_rxcLensIsSpeedyRx === 'true' && isItemSpeedyEligible &&
                                <>
                                    <div className='speedy-rx-banner'>
                                        <span className='speedy-rx-banner-text'>{getLabelFallback('SPEEDY_RX_BANNER_TEXT')}</span>
                                    </div>
                                </>
                            }      
                            <a
                                data-element-id='Prod_ProdLink'
                                title={item.modelName}
                                href={`${config.hostname}${seoUrl}/${item.frame.partNumber}`}
                                className="cart-product-tile-image">
                                    <Image 
                                        width={"256px"}
                                        height={"132px"}
                                        src={!!item.frame.xitem_rxcImagery && !!item.frame.xitem_rxcImagery.productImage ? item.frame.xitem_rxcImagery.productImage : item.frame.xitem_imgUrl}                                        
                                        alt={item.brand+ ' '+ item.modelName}
                                    />
                            </a>
                            <div className="cart-product-tile-cta">
                                <button 
                                    data-element-id = 'Prods_Remove'
                                    className="primary-button" 
                                    onClick={() => setIsBeingDelete(true)}>
                                    { getLabelFallback('REMOVE_ITEM_LABEL') }
                                </button>

                                {/*TODO RESTORE WHEN SAVE ITEM IS AVAILABLE
                                <button 
                                    data-element-id='Prods_SaveForLater'
                                    className="primary-button" 
                                    onClick={() => alert('save')}>
                                    { getLabelFallback('SAVE_ITEM_LABEL') }
                                </button>*/}
                            </div>
                        </div>
                        <div className="cart-product-tile-right">
                            <div>
                                <div className="cart-product-tile-right-top">
                                    <div className="cart-product-tile-right-top-left">
                                        <div className="cart-product-tile-right-top-left-brand">
                                            {(!!item.badgeChannel && item.badgeChannel !== '')? item.brand + ' ' + item.badgeChannel : item.brand}

                                            {(!!item.sales && item.sales !== ''&& !hasInsuranceDiscount())?
                                                <span className="cart-product-tile-right-top-left-brand-badge">{item.sales.substring(1, item.sales.length)} {getLabelFallback('OFF_LABEL')}</span>                                                                               	
                                            :
                                            ((!!item.sales_ea && item.sales_ea !== ''&& !hasInsuranceDiscount() && getCookie('eaactivity')=='true' && config.ea_enabled == 'true')?
                                                <span className="cart-product-tile-right-top-left-brand-badge">{item.sales_ea.substring(1, item.sales_ea.length)} {getLabelFallback('OFF_LABEL')}</span>
                                            :<></>)
                                            }
                                        </div>
                                        <div className="cart-product-tile-right-top-left-model">
                                            {item.modelName}
                                        </div>
                                    </div>
                                    <div className="cart-product-tile-right-top-right">
                                        <div className="cart-product-tile-right-top-price">
                                            {item.frame.hasPromotions === true &&
                                                <span className="cart-product-tile-right-top-price-discount">
                                                    { getLabelFallback('CURRENCY_LABEL') }
                                                    {item.frame.finalPrice}
                                                </span>
                                            }
                                            <span>{ getLabelFallback('CURRENCY_LABEL') }{item.frame.finalDiscountPrice}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="cart-product-tile-right-center">
                                    <div 
                                        data-analytics_available_call='0'
                                        className="cart-product-tile-right-center-label"
                                        onClick={() => {setLensDetailVisible(lensDetailVisible => lensDetailVisible = !lensDetailVisible)}}>
                                        <button data-analytics_available_call='0' className="cart-product-tile-right-center-label-text">
                                            { getLabelFallback('YOUR_LENSES_LABEL') }
                                            <span className="cart-product-tile-right-center-label-text-icon">
                                                {!lensDetailVisible ? 
                                                    <ArrowDown width={"16px"} height={"16px"} viewBox={"0 -8 12 24"} /> :
                                                    <ArrowUp width={"16px"} height={"16px"} viewBox={"0 -8 12 24"} />
                                                }
                                            </span>
                                        </button>
                                        
                                        {!!item.lenses.productId && 
                                            <span className="cart-product-tile-right-center-label-right">
                                                {(item.lenses.hasPromotions === true || item.addOns.hasPromotions === true) && 
                                                    <span className="line-through">
                                                        {getLabelFallback('CURRENCY_LABEL')}
                                                        {convertNumber(parseFloat(item.lenses.finalPrice) + parseFloat(item.addOns.finalPrice))}
                                                    </span>
                                                }
                                                {convertNumber(parseFloat(item.lenses.finalDiscountPrice) + parseFloat(item.addOns.finalDiscountPrice)) !== '0.00' &&
                                                    <span>
                                                        {getLabelFallback('CURRENCY_LABEL')}
                                                        {convertNumber(parseFloat(item.lenses.finalDiscountPrice) + parseFloat(item.addOns.finalDiscountPrice))}
                                                    </span>
                                                }                                    
                                            </span>
                                        }
                                    </div>
                                
                                    {!!item.frame.xitem_rxcReviewObject &&
                                        <div className={`cart-product-tile-right-center-content ${lensDetailVisible ? 'show' : ''}`}>
                                            {getItemDetailedProperty()}
                                            <span className={`left-${item.frame.xitem_rxcReviewObject.length}`}></span>
                                            <button data-element-id='Prods_Edit' className={`primary-button cart-product-tile-right-center-content-button right-${item.frame.xitem_rxcReviewObject.length}`} onClick={() => editOrderItem()}>{getLabelFallback('EDIT_ITEM_LABEL')}</button>
                                        </div>
                                    }
                                </div>
                                {
                                    config.isSpeedyRxEnabled === 'true' && !!selectedShippingMode && selectedShippingMode.shipModeCode.toLowerCase() === 'speedy rx' && !!item.lenses && !!item.lenses.xitem_rxcLensIsSpeedyRx && item.lenses.xitem_rxcLensIsSpeedyRx === 'true' && isItemSpeedyEligible &&
                                        <div className='cart-product-tile-right-center speedy-rx-detail'>
                                            <div className='speedy-rx-detail-text-and-tooltip'>
                                                <span className='speedy-rx-detail-text'>{getLabelFallback('SPEEDY_RX_DETAIL_TEXT')}</span>
                                                <div className='speedy-rx-detail-tooltip-info'>
                                                    <button className={`speedy-rx-detail-tooltip-info-button ${showSpeedyDetailTooltip === true ? 'open-tip' : ''}`} aria-label={'Open tooltip'} onClick={() => setShowSpeedyDetailTooltip(showSpeedyDetailTooltip => showSpeedyDetailTooltip = !showSpeedyDetailTooltip)}>
                                                        <Info/>
                                                    </button>
                                                    {!!showSpeedyDetailTooltip && (
                                                            <div className='speedy-rx-detail-tooltip'>
                                                                <div className='speedy-rx-detail-tooltip-title-and-close'>
                                                                    <span className='speedy-rx-detail-tooltip-title-and-close-label'>
                                                                        {getLabelFallback('SPEEDY_RX_TOOLTIP_TITLE')}
                                                                    </span>
                                                                    <button aria-label={'Close tooltip'} onClick={() => setShowSpeedyDetailTooltip(showSpeedyDetailTooltip => showSpeedyDetailTooltip = !showSpeedyDetailTooltip)}><Close /></button>
                                                                </div>
                                                                <div className='speedy-rx-detail-tooltip-text'>
                                                                    <span className='speedy-rx-detail-tooltip-text-content'>
                                                                        {getLabelFallback('SPEEDY_RX_TOOLTIP_TEXT')}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className='speedy-rx-detail-price'>
                                                {getLabelFallback('CURRENCY_LABEL') + parseFloat(getSpeedyRXPrice()).toFixed(2)}
                                            </div>
                                        </div>
                                }
                                { 
                                    config.warranty.enableWarranty.toLowerCase() === "true" && 
                                     warrantycond() &&
                                    <div className="cart-product-tile-right-center warranty-checkbox-div">
                                            <Checkbox
                                                className={`warranty-checkbox ${isWarrantyChecked && 'checked'}`}
                                                checked={isWarrantyChecked}
                                                onChange={handleWarrantyCheckboxChange}
                                                color="primary"
                                            />
                                            <div className="warranty-checkbox-div-label">
                                            {<><span>{getLabelFallback('ADD_WARRANTY_1')} </span>
                                                <a className='eyewear-protection-plan-link' href='/gl-us/eye-protection-plan'  target='_blank'>{getLabelFallback('ADD_WARRANTY_2')}</a>
                                                {!isWarrantyChecked && <span className='eyewear-protection-plan-grey-price'>{item.lenses.xitem_correctionType && item.lenses.xitem_correctionType === 'Progressive' ? "($34.99)" : "($24.99)"}</span>}
                                                {isWarrantyChecked && <span className='eyewear-protection-plan-price'>{item.lenses.xitem_correctionType && item.lenses.xitem_correctionType === 'Progressive' ? "$34.99" : "$24.99"}</span>}
                                            </>}
                                            </div>
                                    </div>
                                }
                                {
                                    (getPromoSection().length > 0) &&
                                        <div className="cart-product-tile-right-center-bottom">
                                            <div className="cart-product-tile-right-center-bottom-left">
                                                { getLabelFallback('PROMO_APPLIED_LABEL') }:
                                            </div>
                                            <div className="cart-product-tile-right-center-bottom-right">
                                                {hasInsuranceDiscount() ?  getInsuranceCheck() : getPromoSection()}
                                            </div>
                                        </div>
                                }
                            </div>
                            <div>
                                <div className="cart-product-tile-right-bottom">
                                    <div className="cart-product-tile-right-bottom-label">
                                        { getLabelFallback('SUBTOTAL_LABEL') }
                                    </div>
                                    <span className="cart-product-tile-right-bottom-label">
                                        {getItemTotalPrice(item) !== getItemDiscountedTotalPrice(item) &&
                                            <label className="cart-product-tile-right-bottom-label-left">
                                                { getLabelFallback('CURRENCY_LABEL')}
                                                {!!cart.orderItem?.find(warrantyItem => (warrantyItem.comments == "WARRANTY" && warrantyItem.xitem_field1 == item.frame.orderItemId))?.orderItemPrice ? 
                                                getItemTotalPriceWithWarranty(item, cart.orderItem?.find(warrantyItem => (warrantyItem.comments == "WARRANTY" && warrantyItem.xitem_field1 == item.frame.orderItemId))?.orderItemPrice) :
                                                getItemTotalPrice(item)}
                                            </label>
                                        }
                                        <label className="cart-product-tile-right-bottom-label-right">
                                            { getLabelFallback('CURRENCY_LABEL') }
                                            {!!cart.orderItem?.find(warrantyItem => (warrantyItem.comments == "WARRANTY" && warrantyItem.xitem_field1 == item.frame.orderItemId))?.orderItemPrice ?
                                            getItemDiscountedTotalPriceWithWarranty(item, cart.orderItem?.find(warrantyItem => (warrantyItem.comments == "WARRANTY" && warrantyItem.xitem_field1 == item.frame.orderItemId))?.orderItemPrice) :
                                            !!selectedShippingMode && selectedShippingMode.shipModeDescription.toLowerCase() === 'speedy rx' ? getItemDeiscountedTotalPriceWithSpeedy(item, selectedShippingMode.field2) : getItemDiscountedTotalPrice(item)}
                                        </label>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </>
                }
                {
                    isBeingDelete === true && 
                        <div className="cart-product-tile-deleting">
                            <div className="cart-product-tile-deleting-left">
                                <span>{item.brand+ ' '+ item.modelName}</span>{ getLabelFallback('UNDO_MESSAGE_LABEL') }
                            </div>
                            <div className="cart-product-tile-deleting-right">
                                <button className="primary-button" onClick={() => {setIsBeingDelete(false)}}>{getLabelFallback('UNDO_LABEL')}</button>
                            </div>
                        </div>
                }
                
            </div>
            {isBeingDelete === false && config.cartLensUpsell.enabled === true && item.frame.xitem_laResults == null && selectedShippingMode.shipModeCode.toLowerCase() != 'speedy rx' &&
               <>
                    { (sessionStorage.getItem("upsell-current-session-title-" + item.frame.orderItemId) != "" && (sessionStorage.getItem("upsell-current-session-title-"+ item.frame.orderItemId) != undefined) || (item.upsellOpions).length != 0) && 
                    <>
                    <div className="cart-product-tile-upsell" id="cart-product-tile-upsell">
                        <div className="cart-product-tile-upsell-top">
                            <span className='cart-product-tile-upsell-top-message-default' id="cart-product-tile-upsell-top-message-default-ma">{(item.upsellOpions).length != 0 && <> 
                                How about a lens upgrade? 
                            </>}
                            </span>
                            <span className="cart-product-tile-upsell-top-message-added" id="art-product-tile-upsell-top-message-added">{ sessionStorage.getItem("upsell-current-session-title-" + item.frame.orderItemId) != "" &&  sessionStorage.getItem("upsell-current-session-title-"+ item.frame.orderItemId) != undefined &&
                            <>
                                {sessionStorage.getItem("upsell-current-session-title-"+ item.frame.orderItemId)} added
                            </>
                            }
                            </span>
                        </div>
                        {getItemUpsellOption()}                
                    </div>
                    </>
                    } 
                </>
            }
        </div>

        {!!item.moCo.prod_hierarchy_1 && item.moCo.prod_hierarchy_1.toLowerCase() === 'electronics' &&
            <div className="cart-smart-glasses-label">
                <div> 
                <svg width="18" height="18" fill="none" viewBox="0 0 18 18"><path d="M9 0C13.962 0 18 4.038 18 9S13.962 18 9 18A9.011 9.011 0 0 1 0 9C0 4.038 4.038 0 9 0zm0 17.25A8.259 8.259 0 0 0 17.25 9 8.259 8.259 0 0 0 9 0.75 8.259 8.259 0 0 0 0.75 9 8.259 8.259 0 0 0 9 17.25z" fill="#000"/><path d="M8.626 6.75h0.748V13.5h-0.748V6.75zm0 -2.25h0.748v0.75h-0.748V4.5z" fill="#000"/></svg>
                </div>                
                <p>{getLabelFallback('SMART_GLASSES_MINIMUM_YEARS_OLD_LABEL')}</p>
            </div>
        }          
        </>
    );
}

export default CartProductTile;
